import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="otp-toggle"
export default class extends Controller {
  static targets = ["checkbox", "emailSection"]

  connect() {
    this.toggle() // Eseguito al caricamento iniziale
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.emailSectionTarget.style.display = "block"
    } else {
      this.emailSectionTarget.style.display = "none"
    }
  }
}